import { useFormContext } from 'react-hook-form';

import { FileMimeTypes, FilePicker } from '@/modules/common';

import { maxVideoPreviewSize } from '../../../constants';

type FileState = {
  error: string;
  file: File | null;
};

type VideoPreviewProps = {
  onFileChange: (key: string, file: File) => void;
  filesState: {
    [key: string]: FileState;
  };
  retryUpload?: () => void;
  isUploading?: boolean;
};

export const VideoTab = ({
  onFileChange,
  retryUpload,
  isUploading,
  filesState,
}: VideoPreviewProps) => {
  const { control } = useFormContext();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-col grid-rows-6 sm:grid-rows-1 gap-6">
      <FilePicker
        control={control}
        label="Idle state video (displayed when the app first opens)"
        name="idleStateVideoPublicUrl"
        accept={[FileMimeTypes.Mp4, FileMimeTypes.Mov, FileMimeTypes.Webm]}
        onRetry={retryUpload}
        useVideoIcon
        isUploading={isUploading}
        file={filesState.idleStateVideoPublicUrl?.file}
        error={filesState.idleStateVideoPublicUrl?.error}
        onFileChange={onFileChange}
        placeholder="Add video file"
        tips={
          <p className="text-sm text-zinc-500">
            The file must be in
            <span className="text-zinc-100">&nbsp;mp4 .webm .mov&nbsp;</span>
            formats and maximum size 100 MB.
          </p>
        }
        maxFileSize={maxVideoPreviewSize}
      />

      <FilePicker
        control={control}
        label="Event loading video"
        name="publicUrl"
        useVideoIcon
        accept={[FileMimeTypes.Mp4, FileMimeTypes.Mov, FileMimeTypes.Webm]}
        onRetry={retryUpload}
        isUploading={isUploading}
        file={filesState.publicUrl?.file}
        error={filesState.publicUrl?.error}
        onFileChange={onFileChange}
        placeholder="Add video file"
        tips={
          <p className="text-sm text-zinc-500">
            The file must be in
            <span className="text-zinc-100">&nbsp;mp4 .webm .mov&nbsp;</span>
            formats and maximum size 100 MB.
          </p>
        }
        maxFileSize={maxVideoPreviewSize}
        requiredMark
      />
    </div>
  );
};
